import { ObservableArray, View, ViewModel } from "binder";
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ProductSelector extends SearchableSelectorBaseViewModel<product>{
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    protected async loadById(id: string): Promise<product> {
        let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/SearchProductsById',{
            Id:id
        });
        return result.Products.map(x=>this.convertSingle(x))[0];
    }
    
    protected async loadData(searchedText: string): Promise<product[]> {
        let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/SearchProducts',{
            SearchText:searchedText,
            ResultCount:20
        });
        return result.Products.map(x=>this.convertSingle(x));
    }
    
    private convertSingle(dto:any):product{
        var p = new product(this);
        p.id = dto.Id;
        p.name = dto.ProductName;
        p.code = dto.ProductCode;
        p.title = `${p.name}(${p.code})`;
        p.measuredProducts.update(...dto.MeasuredProducts.map(x=>{
            let y = new measuredProductDto(this);
            y.unitName = x.UnitName;
            y.unitId = x.UnitId;
            y.id = x.MeasuredProductId;
            return y;
        }));
        return p;
    }
}

export class product extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.measuredProducts = ObservableArray.create();  
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set measuredProducts(v: ObservableArray<measuredProductDto>) { this._measuredProducts = v; } public get measuredProducts(): ObservableArray<measuredProductDto> { return this._measuredProducts;} private _measuredProducts: ObservableArray<measuredProductDto>;
}

export class measuredProductDto extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set unitId(v: string) { this._unitId = v; } public get unitId(): string { return this._unitId;} private _unitId: string;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    
}
